// Using example of documentation in https://tanstack.com/query/latest/docs/framework/react/plugins/persistQueryClient#building-a-persister

import { get, set, del } from 'idb-keyval'
import {
  PersistedClient,
  Persister,
} from '@tanstack/react-query-persist-client'

export const IDB_VALID_KEY_PREFIX = 'reactQuery'

/**
 * Creates an Indexed DB persister
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
export function createIDBPersister() {
  const combinedKey = `${IDB_VALID_KEY_PREFIX}-${
    import.meta.env.VITE_ENVIRONMENT
  }`
  return {
    persistClient: async (client: PersistedClient) => {
      await set(combinedKey, client)
    },
    restoreClient: async () => {
      return await get<PersistedClient>(combinedKey)
    },
    removeClient: async () => {
      await del(combinedKey)
    },
  } satisfies Persister
}
